import {
  Button,
  List,
  Space,
  Card,
  Statistic,
  Progress,
  Typography,
  Divider,
  Row,
  Col,
  Spin
} from "antd";
import { NAIRA } from "../../defaults/utilities";
import { useState } from "react";
import { DownloadOutlined, FileTextOutlined, BankOutlined, CalendarOutlined } from '@ant-design/icons';
import { formatCurrency } from "../../helpers/currency";
import { useDownloadBudgetReport } from "../../hooks/budget/budgetQuery";
import { userStore } from "../../store/userStore";
import {InflowOutflow, NewInflowOutflow} from "../budgets/inflowOutflow";
import { InflowOutflowManager } from "../voucher/inflowOutflowManager";

const { Title, Text } = Typography;

export default function PreviewFinalAccount({ item, handleModalClose, updateItem }) {
  const [year, setYear] = useState(item.financialYear.id);
  const [department, setdepartment] = useState(item?.office?.id);
  const [downloading, setDownloading] = useState(false);

  const user = userStore(state => state.user);
  const downloadBudgetReport = useDownloadBudgetReport();

  // Calculate totals
  const totalBudget = item.budgetItems.map(b => b.amount).reduce((i, c) => i + c, 0);
  const totalSpent = item.budgetItems.map(b => b.spent).reduce((i, c) => i + c, 0);
  const totalRemaining = totalBudget - totalSpent;
  const spentPercentage = Math.round((totalSpent / totalBudget) * 100) || 0;

  const downloadReport = async () => {
    setDownloading(true)
    await downloadBudgetReport(department, year, false)
    setDownloading(false)
  }

  return (
    <div style={{ maxHeight: "80vh", overflowY: "auto", padding: "1.5em" }}>
      {/* Header Card with Account Information */}
      <Card
        title={<Title level={4}><FileTextOutlined /> Final Account Details</Title>}
        style={{ marginBottom: "1.5em", boxShadow: "0 2px 8px rgba(0,0,0,0.09)" }}
      >
        <Row gutter={[24, 24]}>
          <Col span={12}>
            <Card bordered={false}>
              <Statistic
                title="Final Account Title"
                value={item?.title}
                valueStyle={{ color: '#1890ff', fontWeight: "bold" }}
              />
            </Card>
          </Col>
          <Col span={12}>
            <Card bordered={false}>
              <Statistic
                title="Financial Year"
                value={item.financialYear?.title}
                prefix={<CalendarOutlined />}
                valueStyle={{ color: '#1890ff', fontWeight: "bold" }}
              />
            </Card>
          </Col>
        </Row>
      </Card>

      {/* Summary Card with Budget Statistics */}
      <Card
        title={<Title level={4}>Budget Summary</Title>}
        style={{ marginBottom: "1.5em", boxShadow: "0 2px 8px rgba(0,0,0,0.09)" }}
      >
        <Row gutter={[24, 24]}>
          <Col span={8}>
            <Statistic
              title="Total Budget"
              value={totalBudget}
              precision={2}
              valueStyle={{ color: '#1890ff' }}
              prefix={NAIRA}
              formatter={(value) => formatCurrency(value)}
            />
          </Col>
          <Col span={8}>
            <Statistic
              title="Total Spent"
              value={totalSpent}
              precision={2}
              valueStyle={{ color: '#cf1322' }}
              prefix={NAIRA}
              formatter={(value) => formatCurrency(value)}
            />
          </Col>
          <Col span={8}>
            <Statistic
              title="Remaining Balance"
              value={totalRemaining}
              precision={2}
              valueStyle={{ color: '#3f8600' }}
              prefix={NAIRA}
              formatter={(value) => formatCurrency(value)}
            />
          </Col>
          <Col span={24}>
            <div style={{ marginTop: "1em" }}>
              <Text>Budget Utilization</Text>
              <Progress
                percent={spentPercentage}
                status={spentPercentage >= 100 ? "exception" : "active"}
                strokeColor={{
                  '0%': '#108ee9',
                  '100%': spentPercentage >= 100 ? '#ff4d4f' : '#87d068',
                }}
              />
            </div>
          </Col>
        </Row>
      </Card>

      {/* Inflow/Outflow Management Section */}
      {item.submitted && (
        <Card
          title={<Title level={4}>Inflow/Outflow Management</Title>}
          style={{ marginBottom: "1.5em", boxShadow: "0 2px 8px rgba(0,0,0,0.09)" }}
        >
          <InflowOutflowManager budgetItem={item} onUpdate={updateItem} />
        </Card>
      )}

      {/* Actions Card */}
      <Card style={{ boxShadow: "0 2px 8px rgba(0,0,0,0.09)" }}>
        <Button
          type="primary"
          icon={<DownloadOutlined />}
          size="large"
          loading={downloading}
          onClick={downloadReport}
          style={{ backgroundColor: "green", borderColor: "green" }}
        >
          Download Report
        </Button>
      </Card>
    </div>
  )
}
